import React, { useState, useEffect } from "react";
import "./CustomPackageDetails.css";
import { Tabs, Tab } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { AddService } from "../../Features/CustomPackages";
import {
  ChooseHotelForm,
  HotelForm,
  FlightForm,
  TotalTrip,
  ComponentRowByDestination,
  ComponentRowByDay,
  WarningModal,
  AddServiceModal,
  AddTransportModal,
  FilterCustomPackageComponents,
  ChooseFlightForm,
  HotelDetails,
  ChooseActivityForm,
} from "../../Features/CustomPackages/index";
import { UpdatePackage } from "../../Features/CustomPackages/index";
import locationIcon from "../../assets/images/packages/svg/location.svg";
import nightIcon from "../../assets/images/packages/svg/night.svg";
import activitiesIcon from "../../assets/images/packages/svg/mountain.svg";
import servicesIcon from "../../assets/images/packages/svg/services.svg";
import transportIcon from "../../assets/images/packages/svg/bus.svg";
import hotelsIcon from "../../assets/images/packages/svg/hotel.svg";
import flightIcon from "../../assets/images/packages/svg/flight.svg";
import dateIcon from "../../assets/images/packages/svg/date-icon.svg";
import editIcon from "../../assets/images/packages/svg/edit-icon.svg";
import { axiosGet, axiosPut, axiosPost } from "../../utils/apis/api";
import ReactCountryFlag from "react-country-flag";
import countryCode from "country-code-lookup";
import Cookies from "js-cookie";
import { SpinnerLoading } from "../../components/index";
import { TextField, Autocomplete } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "../../contexts/TranslationContext";
import GlobalModal from "../../Features/CustomPackages/Components/AddModal/GlobalModal";
import dayjs from "dayjs";
import "dayjs/locale/ar";
import { TransfersForm } from "../../Features/ServicesForms/index";
import { NotFound } from "../../components/index";
const TableHeader = ({ icon, title, first }) => (
  <div className="grid-header-item">
    <div className={`table-title-container ${first ? "first-title" : ""}`}>
      <img className="table-title-img" src={icon} alt={title} />
      <div className="table-title">{title}</div>
    </div>
  </div>
);

const CustomPackageDetails = ({ url }) => {
  const pathSegments = window.location.pathname.split("/");
  const encodedPackageId = pathSegments[pathSegments.length - 1];
  const packageId = encodedPackageId;
  const [travelers, setTravelers] = useState([]);

  const [quotationData, setQuotationData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [subLoading, setSubLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedComponent, setSelectedComponent] = useState(null);
  const [locations, setLocations] = useState(null);
  const [hasMorelocations, setHasMorelocations] = useState(true);
  const PAGE_LIMIT = 50;
  const [totalTrip, setTotalTrip] = useState(false);

  const [days, setDays] = useState([]);
  const [selectedDayHotels, setSelectedDayHotels] = useState({});
  const [modalContext, setModalContext] = useState("destination"); // 'destination' or 'day'

  const [showManualHotelForm, setShowManualHotelForm] = useState(false);
  const [chooseHotelForm, setChooseHotelForm] = useState(false);
  const [showTboHotelDetails, setShowTboHotelDetails] = useState(false);

  const [showManualFlightForm, setShowManualFlightForm] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const [showAllType, setShowAllType] = useState(null);
  const [chooseFlightForm, setChooseFlightForm] = useState(false);

  const [chooseHotel, setChooseHotel] = useState(false);
  const [chooseFlight, setChooseFlight] = useState(false);

  const [addManual, setAddManual] = useState(false);
  const [addManualFlight, setAddManualFlight] = useState(false);

  const [selectedDates, setSelectedDates] = useState({});
  const [selectedDestination, setSelectedDestination] = useState(null);

  const [open, setOpen] = useState(false);
  const [openFlight, setOpenFlight] = useState(false);
  const [openService, setOpenService] = useState(false);
  const [openTransportation, setOpenTransportation] = useState(false);

  const [destinations, setDestinations] = useState([]);
  const [destinationNights, setDestinationNights] = useState({});
  const [totalDays, setTotalDays] = useState(0);
  const [chooseActivityForm, setChooseActivityForm] = useState(false);

  const [deleteModal, setDeleteModal] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [bookWarnings, setBookWarnings] = useState([]);
  const [destinationsWithDates, setDestinationsWithDates] = useState([]);
  const [countryCodes, setCountryCodes] = useState([]);
  const [cumulativeNights, setCumulativeNights] = useState([]);
  const [showUpdatePackage, setShowUpdatePackage] = useState(false);
  const [deletedRowId, setDeletedRowId] = useState(null);
  const [unsavedNights, setUnsavedNights] = useState(null);
  const [dateWarningPopUp, setDateWarningPopUp] = useState(null);
  const [hasShownDateWarning, setHasShownDateWarning] = useState(false);
  const [lastDate, setLastDate] = useState(null);
  const [Items, setItems] = useState([]);
  const Lang = Cookies.get("preferred_language") || "en";

  const [showAddServiceForm, setShowAddServiceForm] = useState(false);
  const [selectedServiceTypes, setSelectedServiceTypes] = useState([]); // ["Visa", "Insurance", ...]
  const lang = Cookies.get("preferred_language") || "en";

  // Transportation
  const [showTransportationForm, setshowTransportationForm] = useState(false);
  const [transportationItems, setTransportationItems] = useState([]);
  const [showReservedTransportation, setShowReservedTransportation] =
    useState(false);

  const [apiError, setApiError] = useState(false);
  const [errorData, setErrorData] = useState(null);

  // Set dayjs locale dynamically
  dayjs.locale(lang === "ar" ? "ar" : "en");

  const { t } = useTranslation();

  const fetchPackageDetails = async (isSubLoading = false) => {
    try {
      setApiError(false);
      setErrorData(null);
      let apiUrl = `${url}/api/method/erpnext.selling.doctype.quotation.quotation.PackageQuotation?quotation_id=${packageId}`;
      if (isSubLoading) {
        setSubLoading(true);
      } else {
        setIsLoading(true);
      }

      const apiKey = Cookies.get("api_key");
      const apiSecret = Cookies.get("api_secret");
      var headers = {
        Authorization: `token ${apiKey}:${apiSecret}`,
      };
      const response = await axiosGet(apiUrl, {}, headers);
      const result = response.result;
      setQuotationData(result);
      if (isSubLoading) {
        setSubLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      if (isSubLoading) {
        setSubLoading(false);
      } else {
        setIsLoading(false);
      }
      setErrorData({
        code: error.response?.status || 500,
        message: error.message || t("anErrorOccurred"),
        description: t("PackageFetchError"),
      });
      setApiError(true);
      return { data: null, error: error.message };
    }

    setSelectedComponent(null);

    setChooseHotelForm(false);
  };

  const fetchLocations = async (
    newSearch = "",
    newStart = 0,
    append = false
  ) => {
    if (!hasMorelocations && append) return; // Stop if no more items
    // setLoading(true);
    try {
      const response = await axiosGet(
        `${url}/api/method/alltimes.www.api.locations`,
        {
          search: newSearch,
          start: newStart,
          limit: PAGE_LIMIT,
        }
      );
      const newItems = Array.isArray(response.result?.locations)
        ? response.result?.locations
        : []; // Ensure array
      setLocations((prevItems) =>
        append ? [...prevItems, ...newItems] : newItems
      );
      setHasMorelocations(newItems.length === PAGE_LIMIT);
      // setStart(newStart + PAGE_LIMIT);
    } catch (error) {
      console.error("Error fetching destinations:", error);
      setLocations([]); // Ensure items is always an array
    } finally {
      // setLoading(false);
    }
  };

  const addComponentToQuot = async (items, isSubLoading = false) => {
    if (isSubLoading) {
      setSubLoading(true);
    } else {
      setIsLoading(true);
    }

    const payload = {
      quotation_id: packageId,
      items: items,
    };

    try {
      const apiKey = Cookies.get("api_key");
      const apiSecret = Cookies.get("api_secret");
      const headers = {
        Authorization: `token ${apiKey}:${apiSecret}`,
      };

      const response = await axiosPost(
        `${url}/api/method/erpnext.selling.doctype.quotation.quotation.add_items_to_quotation`,
        payload,
        headers
      );

      if (response.status === 200) {
        toast.success(t("AddedSuccessfully"), { position: "bottom-right" });
        fetchPackageDetails({ isSubLoading });

        return true; // success
      } else {
        toast.error(
          response.message ?? t("ErrorOccurredWhileAddingReservation"),
          { position: "bottom-right" }
        );
        return false; // failed
      }
    } catch (error) {
      toast.error(error ?? t("ErrorOccurredWhileAddingReservation"), {
        position: "bottom-right",
      });
      console.error("Error:", error);
      return false; // failed
    } finally {
      if (isSubLoading) {
        setSubLoading(false);
      } else {
        setIsLoading(false);
      }

      setOpenService(false);
      setOpenTransportation(false);
    }
  };

  const updateComponentFromQuot = async (from_date, to_date, row_id, isSubLoading = false) => {
  if (isSubLoading) {
      setSubLoading(true);
    } else {
      setIsLoading(true);
    }

    let row = {
      date_from: from_date
        ? dayjs(from_date).format("YYYY-MM-DD HH:mm:ss")
        : null,
    };
    if (to_date) {
      row["date_to"] = dayjs(to_date).format("YYYY-MM-DD HH:mm:ss");
    }
    const payload = {
      quotation_id: packageId,
      row_id: row_id,
      row: row,
    };
    try {
      const apiKey = Cookies.get("api_key");
      const apiSecret = Cookies.get("api_secret");
      var headers = {
        Authorization: `token ${apiKey}:${apiSecret}`,
      };
      const response = await axiosPut(
        `${url}/api/method/erpnext.selling.doctype.quotation.quotation.update_quotation_component`,
        payload,
        headers
      );

      if (response.status === 200) {
        // toast.success(t("UpdatedSuccessfully"), {
        //   position: "bottom-right",
        // });       
        if (unsavedNights === false) {
          fetchPackageDetails({ isSubLoading });
        }
        return true; // success

      } else {
        toast.error(
          response.message ?? t("ErrorOccurredWhileUpdatingPackage"),
          {
            position: "bottom-right",
          }
        );
        return false; // failed

      }
    } catch (error) { // should fix type of error 
      toast.error(t("ErrorOccurredWhileUpdatingPackage"), {
        position: "bottom-right",
      });
      return false; // failed

    }
    finally {
      if (isSubLoading) {
        setSubLoading(false);
      } else {
        setIsLoading(false);
      }
    }
    };

  const updateQuotation = async ({
    destination_list,
    new_dist,
    deleted_items,
    package_name,
    travelers,
    start_date,
    end_date,
  }) => {
    setIsLoading(true);
    var dist = destination_list;

    if (new_dist) {
      dist.push(new_dist);
    }

    var payload = {
      quotation_id: packageId,
    };

    if (dist) {
      payload["destinations"] = dist;
    }
    if (deleted_items) {
      payload["delete_items"] = deleted_items;
      setShowWarning(false);
    }
    if (package_name) {
      payload["package_name"] = package_name;
    }
    if (travelers) {
      payload["travelers"] = travelers;
    }
    if (start_date) {
      payload["start_date"] = dayjs(start_date).format("YYYY-MM-DD");
    }
    if (end_date) {
      payload["end_date"] = dayjs(end_date).format("YYYY-MM-DD");
    }

    try {
      const apiKey = Cookies.get("api_key");
      const apiSecret = Cookies.get("api_secret");
      var headers = {
        Authorization: `token ${apiKey}:${apiSecret}`,
      };

      var response = await axiosPut(
        `${url}/api/method/erpnext.selling.doctype.quotation.quotation.PackageQuotation`,
        payload,
        headers
      );

      if (response.status === 200) {
        toast.success(t("YourPackageUpdates"), {
          position: "bottom-right",
        });
        setIsLoading(false);
        fetchPackageDetails();
        setBookWarnings([]);
        setUnsavedNights(false);
        // onSuccess();
      } else {
        toast.error(
          response.message ?? t("ErrorOccurredWhileUpdatingPackage"),
          {
            position: "bottom-right",
          }
        );
        setIsLoading(false);
      }
    } catch (error) {
      toast.error(error.toString() ?? t("ErrorOccurredWhileUpdatingPackage"), {
        position: "bottom-right",
      });
      setIsLoading(false);
    }
    setDeletedRowId(null);
    setDeleteModal(false);
    setShowUpdatePackage(false);
  };

  useEffect(() => {
    fetchPackageDetails();
  }, []);



  useEffect(() => {
    if (quotationData && quotationData.details) {
      setLastDate(null);
      setDays([]);
      setTotalDays(0);
      setHasShownDateWarning(false);
      if (
        quotationData.details.destinations &&
        quotationData.details.destinations.length > 0
      ) {
        var destinationList = [];
        quotationData.details.destinations.map((country) => {
          destinationList.push(country);
        });
        setDestinations(destinationList);
      } else {
        setDestinations([]);
        setDestinationsWithDates([]);
        setDestinationNights({});
      }
      if (quotationData.details.start_date && quotationData.details.end_date) {
        const start = new Date(quotationData?.details.start_date);
        const end = new Date(quotationData?.details.end_date);
        const timeDiff = end - start;
        const calculatedDays = Math.ceil(timeDiff / (1000 * 3600 * 24)); // + 1 Add 1 to include both start and end dates

        const daysArray = [];
        const currentDate = new Date(start);

        for (let i = 0; i < calculatedDays; i++) {
          daysArray.push({
            date: new Date(currentDate),
            id: i,
          });
          currentDate.setDate(currentDate.getDate() + 1);
        }

        setDays(daysArray);
        setTotalDays(calculatedDays); // Add this line to update totalDays
        // setLastDate(quotationData.details.end_date);
      }

      const travelers = [
        {
          Adults: quotationData.details.number_of_adults || 1,
          Children: quotationData.details.number_of_children || 0,
          ChildrenAges: quotationData.details.ages || [],
        },
      ];

      setTravelers(travelers);
      if (quotationData.items && quotationData.items.length > 0) {
        setItems(quotationData.items);
      } else {
        setItems([]);
      }
    } else {
      setLastDate(null);
      setDays([]);
      setTotalDays(0);
      setHasShownDateWarning(false);
      setDestinations([]);
      setDestinationsWithDates([]);
      setDestinationNights({});
      setTravelers([]);
      setItems([]);
    }
  }, [quotationData]);

  useEffect(() => {
    if (!destinations || destinations.length === 0) return;


    const initialNights = {};

    destinations.forEach((dest, index) => {
      const nights = dest.nights || 0;
      initialNights[dest.idx] = nights;
    });

    setDestinationNights(initialNights);

    const countryCodes = quotationData?.details?.destinations
      .map((country) => {
        const countryName = country.country_location;

        const exactMatch = countryCode.byCountry(countryName);
        if (exactMatch) return exactMatch.iso2;

        const fuzzyMatch = countryCode.countries.find((c) =>
          c.country.toLowerCase().includes(countryName.toLowerCase())
        );

        return fuzzyMatch?.iso2 || null;
      })
      .filter(Boolean);

    const uniqueCountryCodes = [...new Set(countryCodes)];
    setCountryCodes(uniqueCountryCodes);
  }, [destinations]);

  useEffect(() => {
    if (destinations) {
      let cumulativeNightCount = 0;

      const destinationsWithDates = destinations.map((dest, index) => {
        // const isLast = index === destinations.length - 1;
        const currentNights = destinationNights[dest.idx] || 0;

        // Calculate start date based on previous destinations

        const startDate = new Date(quotationData?.details?.start_date);
        startDate.setDate(startDate.getDate() + cumulativeNightCount);
        startDate.setHours(0, 0, 0, 0);
        // Calculate end date
        const endDate = new Date(startDate);
        endDate.setDate(
          startDate.getDate() +
            // (isLast ? totalDays - cumulativeNightCount :
            currentNights
          // )
        );
        endDate.setHours(0, 0, 0, 0);

        const formattedStartDate = dayjs(startDate).format("YYYY-MM-DD");
        const formattedEndDate = dayjs(endDate).format("YYYY-MM-DD");

        // If total nights exceed the package dates
        if (
          dayjs(formattedEndDate).isAfter(
            dayjs(dayjs(quotationData.details.end_date).format("YYYY-MM-DD")), //lastDate
            "day"
          ) &&
          !hasShownDateWarning
        ) {
          setDateWarningPopUp(true);
          setHasShownDateWarning(true);
        }

        // For the last destination, ensure it ends at package end date
        // if (isLast) {
        //   endDate.setTime(new Date(quotationData?.details?.end_date).getTime());
        // }

        const dates = {
          start: formattedStartDate,
          end: formattedEndDate,
        };

        // Update cumulative nights only if not the last destination
        // if (!isLast) {
        cumulativeNightCount += currentNights;
        // }
        setCumulativeNights(cumulativeNightCount);

        return {
          ...dest,
          currentNights:
            // isLast
            // ? totalDays - cumulativeNightCount
            // :
            currentNights,
          dates,
          // isLast,
        };
      });
      setDestinationsWithDates(destinationsWithDates);
    }
  }, [destinationNights]);

  useEffect(() => {
    if (
      destinationsWithDates &&
      destinationsWithDates.length > 0 &&
      isAnyNightUnsaved()
    ) {
      const lastDestinationDate =
        destinationsWithDates[destinationsWithDates.length - 1]?.dates?.end;
      setLastDate(lastDestinationDate);
    } else {
      setLastDate(null);
      if (
        quotationData &&
        quotationData.details &&
        quotationData.details.start_date &&
        quotationData.details.end_date
      ) {
        const start = new Date(quotationData?.details.start_date);
        const end = new Date(quotationData?.details.end_date);
        const timeDiff = end - start;
        const calculatedDays = Math.ceil(timeDiff / (1000 * 3600 * 24)); // + 1 Add 1 to include both start and end dates

        const daysArray = [];
        const currentDate = new Date(start);

        for (let i = 0; i < calculatedDays; i++) {
          daysArray.push({
            date: new Date(currentDate),
            id: i,
          });
          currentDate.setDate(currentDate.getDate() + 1);
        }

        setDays(daysArray);
        setTotalDays(calculatedDays); // Add this line to update totalDays
      }
    }

    // else {
    //   setLastDate(quotationData?.details?.end_date ? new Date(quotationData.details.end_date) : null);
    // }
  }, [destinationsWithDates]);

  useEffect(() => {
    if (
      quotationData &&
      quotationData.details &&
      quotationData.details.start_date &&
      lastDate
    ) {
      const start = new Date(quotationData?.details.start_date);
      const end = new Date(lastDate);
      const timeDiff = end - start;
      const calculatedDays = Math.ceil(timeDiff / (1000 * 3600 * 24)); // + 1 Add 1 to include both start and end dates

      const daysArray = [];
      const currentDate = new Date(start);

      for (let i = 0; i < calculatedDays; i++) {
        daysArray.push({
          date: new Date(currentDate),
          id: i,
        });
        currentDate.setDate(currentDate.getDate() + 1);
      }

      setDays(daysArray);
      setTotalDays(calculatedDays); // Add this line to update totalDays
    }
  }, [lastDate]);

  const formatDate = (date) => {
    const formatter = new Intl.DateTimeFormat("en-US", {
      weekday: "short",
      day: "numeric",
      month: "long",
    });

    const parts = formatter.formatToParts(new Date(date));
    const weekday = parts.find((p) => p.type === "weekday").value;
    const day = parts.find((p) => p.type === "day").value;
    const month = parts.find((p) => p.type === "month").value;

    return `${weekday}, ${day} ${month}`;
  };

  const handleNightsChange = (destId, delta) => {
    // const lastDestId = destinations[destinations.length - 1].idx;
    // if (destId === lastDestId) return;

    const currentNights = destinationNights[destId] || 0;
    const newNights = Math.max(0, currentNights + delta);

    // const maxAllowed = totalDays - usedNights;
    const adjustedNights = newNights; //Math.min(newNights, maxAllowed);

    // Prepare updated nights object
    const updatedNights = {
      ...destinationNights,
      [destId]: adjustedNights,
    };
    setDestinationNights(updatedNights);
  };

  const isAnyNightUnsaved = () => {
    return destinations.some(
      (dest) =>
        destinationNights[dest.idx] !== undefined &&
        destinationNights[dest.idx] !== dest.nights
    );
  };

  const handleAddHotel = () => {
    setChooseHotel(false);
    setAddManual(true);
  };

  const handleAddFlight = () => {
    setChooseFlight(false);
    setAddManualFlight(true);
  };

  const handleChooseHotel = () => {
    setChooseHotel(true);
    setAddManual(false);
  };

  const handleChooseFlight = () => {
    setChooseFlight(true);
    setAddManualFlight(false);
  };
  const handleContinue = () => {
    if (addManual) {
      setShowManualHotelForm(true);
    } else if (chooseHotel) {
      setChooseHotelForm(true);
    }
    setOpen(false);
  };

  const handleContinueFlight = () => {
    if (addManualFlight) {
      setShowManualFlightForm(true);
    } else if (chooseFlight) {
      setChooseFlightForm(true);
    }
    setOpenFlight(false);
  };

  const saveBaseData = (destinationId, destinationItem) => {
    const destination = destinationsWithDates.find(
      (d) => d.idx === destinationId
    );
    setSelectedDates({
      startDate: destination.dates.start,
      endDate: destination.dates.end,
    });
    setSelectedDestination(destinationItem);
  };

  const handleOpenTour = (destinationId, destinationItem) => {
    saveBaseData(destinationId, destinationItem);
    setChooseActivityForm(true);
    setShowAllType("All Time Activity");
  };

  // Open/close the modal
  const handleOpen = (destinationId, destinationItem) => {
    saveBaseData(destinationId, destinationItem);
    setOpen(true);
    setShowAllType("Hotel");
  };

  const handleOpenFlight = (destinationId, destinationItem) => {
    saveBaseData(destinationId, destinationItem);
    setOpenFlight(true);
    setShowAllType("Flight");
  };

  const handleOpenService = (destinationId, destinationItem) => {
    saveBaseData(destinationId, destinationItem);
    setOpenService(true);
    setShowAllType("Service"); 
  };

  const handleOpenTransportation = (destinationId, destinationItem) => {
    saveBaseData(destinationId, destinationItem);
    setOpenTransportation(true);
    setShowAllType("Transportation");
  };

  // Update modal handling
  const handleOpenDayHotel = (date) => {
    setModalContext("day");
    setSelectedDates({
      startDate: date,
      endDate: date, // Single date for days
    });
    setOpen(true);
  };

  useEffect(() => {
    setUnsavedNights(isAnyNightUnsaved());
  }, [destinationNights]);

  useEffect(() => {
    if (!unsavedNights) {
      setDateWarningPopUp(false);
      setHasShownDateWarning(false);
      setBookWarnings([]);
    }
  }, [unsavedNights]);
  const check = () => {
    if (!quotationData || !Items || !destinationsWithDates) return;

    let warningsToAdd = [];
    // Loop through each destination with defined dates
    setBookWarnings([]);
    destinationsWithDates.forEach((dest) => {
      const { name, dates } = dest;

      const allItems = Items;

      if (allItems && allItems.length > 0) {
        // Filter items that match this destination and fall within the specified date range
        const itemsInRange = allItems.filter((item) => {
          const dateFromValid =
            item.date_from && dayjs(item.date_from).isValid();
          const dateToValid = item.date_to && dayjs(item.date_to).isValid();
          return (
            item.destination_row_id === name &&
            ((dateFromValid &&
              dayjs(item.date_from).isSameOrAfter(dayjs(dates.start), "day") &&
              dayjs(item.date_from).isSameOrBefore(dayjs(dates.end), "day")) ||
              (dateToValid &&
                dayjs(item.date_to).isSameOrAfter(dayjs(dates.start), "day") &&
                dayjs(item.date_to).isSameOrBefore(dayjs(dates.end), "day")))
          );
        });
        // Filter items for this destination that are NOT in the date range
        const itemsNotInRange = allItems.filter((item) => {
          if (item.destination_row_id !== name) return false;

          const found = itemsInRange.find(
            (inRangeItem) =>
              inRangeItem.name === item.name &&
              inRangeItem.destination_row_id === item.destination_row_id
          );
          // If not found in the valid range list, it's outside the range
          return !found;
        });

        warningsToAdd.push(...itemsNotInRange);
      }
    });

    if (warningsToAdd.length > 0) {
      setBookWarnings((prev) => {
        const existingRowIds = new Set(prev.map((item) => item.row_id));

        const newItems = warningsToAdd
          .filter((item) => !existingRowIds.has(item.name))
          .map((item) => ({
            ...item,
            row_id: item.name,
          }));

        return [...prev, ...newItems];
      });

      setShowWarning(true);
    } else {
      const updatedDestinations = destinations.map((dest) => {
        const matched = destinationsWithDates.find((d) => d.idx === dest.idx);
        return {
          ...dest,
          nights: destinationNights[dest.idx] ?? dest.nights,
          from_date: matched?.dates?.start ?? null,
          to_date: matched?.dates?.end ?? null,
        };
      });
      // const lastEndDate =
      //   destinationsWithDates.length > 0
      //     ? destinationsWithDates[
      //         destinationsWithDates.length - 1
      //       ].dates?.end
      //     : null;

      const lastEndDate = lastDate
        ? lastDate
        : quotationData?.details?.end_date;

      updateQuotation({
        destination_list: updatedDestinations,
        start_date: quotationData?.details?.start_date,
        end_date: lastEndDate,
      });
    }
  };

  useEffect(() => {
    if (!quotationData || !Items || !destinationsWithDates) {
      setBookWarnings([]);
      return;
    }

    let warningsToAdd = [];
    setBookWarnings([]);
    // Loop through each destination with defined dates

    destinationsWithDates.forEach((dest) => {
      const { name, dates } = dest;

      const allItems = Items;

      if (allItems && allItems.length > 0) {
        // Filter items that match this destination and fall within the specified date range
        const itemsInRange = allItems.filter((item) => {
          const dateFromValid =
            item.date_from && dayjs(item.date_from).isValid();
          const dateToValid = item.date_to && dayjs(item.date_to).isValid();
          return (
            item.destination_row_id === name &&
            ((dateFromValid &&
              dayjs(item.date_from).isSameOrAfter(dayjs(dates.start), "day") &&
              dayjs(item.date_from).isSameOrBefore(dayjs(dates.end), "day")) ||
              (dateToValid &&
                dayjs(item.date_to).isSameOrAfter(dayjs(dates.start), "day") &&
                dayjs(item.date_to).isSameOrBefore(dayjs(dates.end), "day")))
          );
        });

        // Filter items for this destination that are NOT in the date range
        const itemsNotInRange = allItems.filter((item) => {
          if (item.destination_row_id !== name) return false;

          const found = itemsInRange.find(
            (inRangeItem) =>
              inRangeItem.name === item.name &&
              inRangeItem.destination_row_id === item.destination_row_id
          );
          // If not found in the valid range list, it's outside the range
          return !found;
        });

        warningsToAdd.push(...itemsNotInRange);
      }
    });

    if (warningsToAdd.length > 0) {
      setBookWarnings((prev) => {
        const existingRowIds = new Set(prev.map((item) => item.row_id));

        const newItems = warningsToAdd
          .filter((item) => !existingRowIds.has(item.name))
          .map((item) => ({
            ...item,
            row_id: item.name,
          }));

        return [...prev, ...newItems];
      });
    }
  }, [Items]);

  const [showAddSrv, setShowAddSrv] = useState(false);

  const handleEditService = (item) => {
    // const svc = item.reservation_type.replace(" Reservation", "");
    const svc = item?.package_component_id;
    setSelectedServiceTypes([svc]);
    setShowAddSrv(true);
    setShowAddServiceForm(true);
    setShowAll(false);
    setShowAllType(item.package_component_type);
  };



  const handleEditTransportation = (item) => {
    // const svc = item.reservation_type.replace(" Reservation", "");
    const svc = item?.package_component_id;
    setSelectedServiceTypes([svc]);
    setShowReservedTransportation(true);
    setShowAll(false);
    setShowAllType(item.package_component_type);
  };

  /* ---------- Flights ---------- */
  const handleEditFlight = (item) => {
    setSelectedServiceTypes(["Flight"]);
    setShowAddServiceForm(true);
  };

  const handleOpenAddService = () => {
    setSelectedServiceTypes([]);
    setShowAddServiceForm(true);
  };

  const handleRequestQuote = async (packageId) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${url}/api/method/alltimes.www.api.request_custom_package`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${Cookies.get("api_key")}:${Cookies.get(
              "api_secret"
            )}`,
          },
          body: JSON.stringify({
            custom_package: packageId,
          }),
        }
      );

      const result = await response.json();

      if (response.ok && result.message && result.status_code !== 404) {
        toast.success(result.message);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.error("Request Quote Error:", error);
      toast.error(t("SomthingWrongPleaseTryAgain"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="custom-package-container">
      {isLoading ? (
        <div className="loading-container">
          <SpinnerLoading />
        </div>
      ) :
      apiError ? (
        // Show API error
        <NotFound
          errorCode={errorData.code}
          errorMessage={errorData.message}
          description={errorData.description}
        />
      ) :
      (
        <div className="maindashboard-container">
          <div>
            <div
              className="edit-btn-container"
              onClick={() => {
                setAddManualFlight(false);
                setChooseActivityForm(false);
                setChooseFlightForm(false);
                setShowUpdatePackage(true);
                setShowAddServiceForm(false);
                setShowManualFlightForm(false);
                setShowAll(false);
                setShowManualHotelForm(false);
                setTotalTrip(false);
                setShowTboHotelDetails(false);
                setShowAllType(null);
                setshowTransportationForm(false);
                setSelectedComponent(null);
                setSelectedServiceTypes([]);
              }}
              style={{ cursor: "pointer" }}
            >
              <img src={editIcon} alt="" />
              <span className="btn-edit">{t("Edit")}</span>
            </div>
          </div>
          <div className="maindashboard-header">
            <div className="maindashboard-header-content">
              <div div className="maindashboard-header-cities">
                {countryCodes &&
                  countryCodes.map((code, index) => (
                    <ReactCountryFlag
                      key={index}
                      countryCode={code}
                      svg
                      style={{
                        width: "25px",
                        height: "25px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                      title={code}
                    />
                  ))}
              </div>
              <div className="maindashboard-header-title">
                {quotationData?.details?.package_name}
              </div>
              <div className="maindashboard-date">
                {quotationData?.details?.start_date &&
                  (lastDate || quotationData?.details?.end_date) &&
                  `${dayjs(quotationData?.details?.start_date).format(
                    "DD/MM/YYYY"
                  )} - 
              ${dayjs(
                lastDate ? lastDate : quotationData?.details?.end_date
              ).format("DD/MM/YYYY")}`}
              </div>
            </div>
            <div className="main-dashboard-price-container">
              {/* <div className="main-dashboard-price">
                {totalTrip ? (
                  <div className="main-dashboard-price-label">
                    {t("StartFrom")}
                  </div>
                ) : (
                  <div
                    className="show-details-btn"
                    onClick={() => {
                    }}
                  >
                    {t("ShowDetails")}
                  </div>
                )}
              </div> */}

              <div className="main-dashboard-nights-container">
                {/* <div className="main-dasboard-header-nights">
                
                <span>{t("Nights")}</span>
                <span>{t("Planned")}</span>
              </div> */}
                <div className="main-dasboard-header-nights">
                  {Lang === "ar" ? (
                    <>
                      <span>{t("Planned")}</span>
                      <span>{t("Nights")}</span>
                    </>
                  ) : (
                    <>
                      <span>{t("Nights")}</span>
                      <span>{t("Planned")}</span>
                    </>
                  )}
                </div>
                <div className="main-dashboard-header-days">
                  {cumulativeNights} {t("Night")}
                  {/* {cumulativeNights}/{totalDays} */}
                </div>
              </div>
              <div>
                {loading ? (
                  <div style={{ marginLeft: "10px" }}>
                    <SpinnerLoading />
                  </div>
                ) : (
                  <button
                    className="PackageCard-quote-button"
                    onClick={() => handleRequestQuote(packageId)}
                  >
                    {t("RequestQuote")}
                  </button>
                )}
              </div>
            </div>
          </div>

          {showUpdatePackage ? (
            <UpdatePackage
              url={url}
              data={quotationData}
              onReturn={() => {
                setShowUpdatePackage(false);
                setShowManualFlightForm(false);
                setShowManualHotelForm(false);
                setTotalTrip(false);
                setShowTboHotelDetails(false);
                setShowAll(false);
                setShowAllType(null);
                setSelectedComponent(null);
                setShowAddServiceForm(false);
                setSelectedServiceTypes([]);
                setAddManualFlight(false);
                setChooseActivityForm(false);
                setChooseFlightForm(false);
              }}
              onUpdate={updateQuotation}
            />
          ) : totalTrip ? (
            <TotalTrip onReturn={() => setTotalTrip(false)} />
          ) : showManualHotelForm ? (
            <HotelForm
              url={url}
              onReturn={() => {
                setShowManualHotelForm(false);
                setSelectedComponent(null);
              }}
              package_name={packageId}
              selectedDates={selectedDates}
              // selectedDestinationName={selectedDestinationName}
              selectedDestination={selectedDestination}
              onSuccess={() => {
                setShowManualHotelForm(false);
              }}
              Refresh={() => {
                if (unsavedNights === false) fetchPackageDetails();
              }}
              package_component_id={selectedComponent !==null? selectedComponent.package_component_id: null}
              setItems={setItems}
            />
          ) : chooseHotelForm ? (
            <ChooseHotelForm
              url={url}
              packageId={packageId}
              onReturn={() => setChooseHotelForm(false)}
              // onHotelSelected={handleHotelSelected}
              dates={selectedDates}
              destination={selectedDestination}
              onSuccess={() => fetchPackageDetails()}
              travelersRooms={travelers}
              // onTravelersRoomsChange={setTravelers}
              nationality={quotationData?.details.nationality_abbr}
            />
          ) : chooseFlightForm ? (
            <ChooseFlightForm
              url={url}
              quotationId={packageId}
              onReturn={(items) => {
                setChooseFlightForm(false);
                if (items) addComponentToQuot(items);
              }}
              dates={selectedDates}
              selectedDestination={selectedDestination}
              setItems={setItems}
              updateComponentFromQuot= {updateComponentFromQuot}
              addComponentToQuot={ addComponentToQuot}
              selectedComponent={selectedComponent}
            />
          ) : chooseActivityForm ? (
            <ChooseActivityForm
              url={url}
              onReturn={(items) => {
                setChooseActivityForm(false);
                if (items) {
                  addComponentToQuot(items);
                }
              }}
              dates={selectedDates}
              selectedDestination={selectedDestination}
            />
          ) : // <ChooseActivityForm
          //   url={url}
          //   onReturn={() => {
          //     setShowAll(false);
          //     setShowAllType(null);
          //     setChooseActivityForm(false);
          //     fetchPackageDetails();
          //   }}
          //   dates={selectedDates}
          //   selectedDestination={selectedDestination}
          //   quotationId={packageId}
          //   componentType={showAllType}
          //   // showAll={showAll}
          // />
          showManualFlightForm ? (
            <FlightForm
              url={url}
              onReturn={() => {
                setShowManualFlightForm(false);
                setSelectedComponent(null);
              }}
              package_name={packageId}
              selectedDates={selectedDates}
              selectedDestination={selectedDestination}
              onSuccess={() => {
                setShowManualFlightForm(false);
              }}
              onRefresh={() => {
                if (unsavedNights === false) {
                  fetchPackageDetails();
                }
              }}
              package_component_id={selectedComponent!==null ? selectedComponent.package_component_id: null}
              setItems={setItems}
            />
          ) : showTboHotelDetails ? (
            <HotelDetails
              url={url}
              hotel={selectedComponent}
              // onBack={handleBackToList}
              dates={selectedDates}
              // nights={nights}
              // onSuccess={onSuccess}
              packageId={packageId}
              selectedDestination={selectedDestination}
              fetchFromApi={true}
              onReturn={() => {
                setShowTboHotelDetails(false);
                setSelectedComponent(null);
              }}
            />
          ) :
          
          // This For Edit Transportation
          showReservedTransportation ? (
            <TransfersForm
              url={url}
              quotationId={packageId}
              transportationItems={[
                {
                  package_component_id: selectedComponent.package_component_id,
                  package_component_type:
                  selectedComponent.package_component_type,
                },
              ]}
              editingComponent={selectedComponent}
              isEditMode={true}
              onReturn={() => {
                setShowReservedTransportation(false);
                setShowAll(true);
                setShowAllType("Transportation");
                setSelectedComponent(null);
              }}
              onSubmit={() => {
                // No need to save since reservation id didnt change
                // hide form when done
                setShowReservedTransportation(false);
                setshowTransportationForm(false);
              }}
              onNext={(item) => {
                return addComponentToQuot(item, { isSubLoading: true });
              }}
              onUpdateQuot={(start_date,end_date ) => {
               return updateComponentFromQuot(start_date,end_date, selectedComponent.name, { isSubLoading: true });
                // setShowAddServiceForm(false);
              }}
              // editingComponent={{
              //   package_component_id: selectedComponent.package_component_id,
              //   reservation_id: selectedComponent.reservation_id,
              //   name: selectedComponent.name,
              // }}
              
              selectedDates={selectedDates}
              
              setItems={setItems}
            ></TransfersForm>
          ) : showAddServiceForm ? (
            <AddService
              url={url}
              quotationId={packageId}
              selectedServices={selectedServiceTypes}
              // editingComponent={{
              //   component_id: editingComponent?.reservation_id,
              //   component_type: editingComponent?.reservation_type,
              //   component_row_id: editingComponent?.name,
              //   service_has_form: editingComponent?.service_has_form,
              //   service_name: editingComponent?.package_component_id,
              //   service_start_date: editingComponent?.

              // }}
              editingComponent={selectedComponent}
              selectedDestination={selectedDestination}
              selectedDates={selectedDates}
              onSubmit={() => {
                // addComponentToQuot(items);
                // setShowAddServiceForm(false);
                fetchPackageDetails();
              }}
              onNext={(item) => {
                return addComponentToQuot(item, { isSubLoading: true });
              }}
              onUpdateQuot={(start_date,end_date ) => {
               return updateComponentFromQuot(start_date,end_date, selectedComponent.name, { isSubLoading: true });
                // setShowAddServiceForm(false);
              }}
              onReturn={() => {
               setShowAddServiceForm(false);
                  setShowAll(true);
                  setShowAllType(showAllType); // Make sure this is set correctly
                  setSelectedComponent(null);
                  setSelectedServiceTypes([]);
              }}
              setItems={setItems}
            />
          ) : 
          ///This For Add Transportation Form have transportationItems from modal 
          showTransportationForm && transportationItems.length > 0 ? (
            <TransfersForm
              url={url}
              quotationId={packageId}
              selectedDestination={selectedDestination}
              selectedDates={selectedDates}
              transportationItems={transportationItems}
              onSubmit={(items) => {
                // addComponentToQuot(items);
                setshowTransportationForm(false);
                fetchPackageDetails();
              }}
              onNext={(item) => {
                return addComponentToQuot(item, { isSubLoading: true });
              }}
              onUpdateQuot={(start_date,end_date ) => {
               return updateComponentFromQuot(start_date,end_date, selectedComponent.name, { isSubLoading: true });
                // setShowAddServiceForm(false);
              }}
              onReturn={() => {
                setShowReservedTransportation(false);
                setshowTransportationForm(false)
                setShowAll(true);
                setShowAllType("Transportation");
                setSelectedComponent(null);
       
              }}
              setItems={setItems}
            />
          ) : showAll ? (
            <FilterCustomPackageComponents
              url={url}
              quotationId={packageId}
              selectedDates={selectedDates}
              selectedDestination={selectedDestination}
              onEditService={handleEditService}
              onEditFlight={handleEditFlight}
              onReturn={() => {
                setShowAll(false);
                setShowAllType(null);
                setSelectedComponent(null);
                // if (bookWarnings.length === 0) {
                if (unsavedNights === false) {
                  fetchPackageDetails();
                }
              }}
              componentType={showAllType}
              showAll={showAll}
              packageName={packageId}
              setSelectedComponent={setSelectedComponent}
              selectedComponent={selectedComponent}
              onAlreadyReservedFlight={() => {
                setShowManualFlightForm(true);
              }}
              onAlreadyReservedHotel={() => {
                setShowManualHotelForm(true);
              }}
              onTboReservedHotel={(hotel) => {
                // setSelectedHotel(hotel)
                setShowTboHotelDetails(true);
              }}
              onReservedTransportation={() => {
                setShowReservedTransportation(true);
              }}
              onEditTransportation={handleEditTransportation}
              setItems={setItems}
              bookWarnings={bookWarnings}
              subLoading={subLoading}
            ></FilterCustomPackageComponents>
          ) : (
            <div className="maindashboard-body">
              <Tabs defaultActiveKey="flights">
                <Tab eventKey="flights" title={t("Destinations")}>
                  <div className="maindashboard-table-container">
                    <div className="maindashboard-table-header">
                      <TableHeader
                        first={true}
                        icon={locationIcon}
                        title={t("Destinations")}
                      />
                      <TableHeader icon={nightIcon} title={t("Nights")} />
                      <TableHeader icon={hotelsIcon} title={t("Hotels")} />
                      <TableHeader icon={flightIcon} title={t("Flights")} />
                      <TableHeader
                        icon={transportIcon}
                        title={t("Transports")}
                      />
                      <TableHeader
                        icon={activitiesIcon}
                        title={t("Activities")}
                      />
                      <TableHeader icon={servicesIcon} title={t("Services")} />
                    </div>

                    <div className="maindashboard-table-body">
                      {destinationsWithDates.map((dest) => (
                        <ComponentRowByDestination
                          key={dest.idx}
                          quotationData={quotationData}
                          destination={dest}
                          setSelectedComponent={setSelectedComponent}
                          // onRemoveHotel={() => handleRemoveHotel(dest.idx)}
                          // onShowHotel={handleShowHotel}
                          openAddHotel={() => {
                            handleOpen(dest.idx, dest);
                          }}
                          openAddFlight={() => {
                            handleOpenFlight(dest.idx, dest);
                          }}
                          openAddService={() => {
                            handleOpenService(dest.idx, dest);
                          }}
                          openAddTransportation={() => {
                            handleOpenTransportation(dest.idx, dest);
                          }}
                          nights={dest.currentNights}
                          onNightsChange={handleNightsChange}
                          startDate={dest.dates.start}
                          endDate={dest.dates.end}
                          isLast={dest.isLast}
                          openAddTour={() => handleOpenTour(dest.idx, dest)}
                          // setShowManualHotelForm={setShowManualHotelForm}
                          // setShowManualFlightForm={setShowManualFlightForm}
                          setDeleteModal={setDeleteModal}
                          saveBaseData={() => saveBaseData(dest.idx, dest)}
                          onClickShowAll={() => {
                            saveBaseData(dest.idx, dest);
                            setShowAll(true);
                          }}
                          onClickShowAllType={(val) => setShowAllType(val)}
                          disabled={unsavedNights}
                          setDeletedRowId={() => setDeletedRowId(dest.primary_destination_row_id)}
                          bookWarnings={bookWarnings}
                          // deleteModal={deleteModal}
                        />
                      ))}
                      <div className="add-destination-row">
                        <div className="autocomplete-wrapper">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M13 13V20C13 20.2652 12.8946 20.5196 12.7071 20.7071C12.5196 20.8946 12.2652 21 12 21C11.7348 21 11.4804 20.8946 11.2929 20.7071C11.1054 20.5196 11 20.2652 11 20V13H4C3.73478 13 3.48043 12.8946 3.29289 12.7071C3.10536 12.5196 3 12.2652 3 12C3 11.7348 3.10536 11.4804 3.29289 11.2929C3.48043 11.1054 3.73478 11 4 11H11V4C11 3.73478 11.1054 3.48043 11.2929 3.29289C11.4804 3.10536 11.7348 3 12 3C12.2652 3 12.5196 3.10536 12.7071 3.29289C12.8946 3.48043 13 3.73478 13 4V11H20C20.2652 11 20.5196 11.1054 20.7071 11.2929C20.8946 11.4804 21 11.7348 21 12C21 12.2652 20.8946 12.5196 20.7071 12.7071C20.5196 12.8946 20.2652 13 20 13H13Z"
                              fill="#9B9B9B"
                            />
                          </svg>

                          <Autocomplete
                            disabled={unsavedNights}
                            options={locations || []}
                            getOptionLabel={(option) =>
                              option.location_name || ""
                            }
                            onInputChange={(event, value) => {
                              fetchLocations(value);
                            }}
                            onFocus={() => {
                              fetchLocations();
                            }}
                            // onClick={fetchLocations()}
                            value={""}
                            onChange={(event, selectedOption) => {
                              if (selectedOption) {
                                updateQuotation({
                                  destination_list: destinations,
                                  new_dist: {
                                    location: selectedOption.name,
                                    country_location:
                                      selectedOption.country_location,
                                    country_code: selectedOption.country_code,
                                    nights: 0,
                                    from_date:
                                      quotationData?.details?.end_date ?? null,
                                    to_date:
                                      quotationData?.details?.end_date ?? null,
                                  },
                                });
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder={t("SelectCountries")}
                                size="small"
                                InputProps={{
                                  ...params.InputProps,
                                  disableUnderline: true,
                                  endAdornment: null, // Removes dropdown icon
                                  sx: {
                                    width: "100%",
                                    color: "#9B9B9B",
                                    fontFamily: "Dmsans400",
                                    fontSize: "14px !important",
                                    fontWeight: "400",
                                    boxShadow: "none",
                                    border: "none",
                                    marginTop: "0px !important",
                                    outline: "none",
                                    "& fieldset": {
                                      border: "none",
                                    },
                                  },
                                }}
                              />
                            )}
                            sx={{
                              width: "100%",
                              mt: 1,
                              "& .MuiAutocomplete-inputRoot": {
                                fontSize: "14px",
                                border: "none",
                                marginTop: "0px !important",
                              },
                            }}
                          />
                        </div>
                      </div>
                      {unsavedNights && (
                        <div style={{ textAlign: "right" }}>
                          <button
                            className={`save-btn ${
                              isLoading ? "opacity-50 cursor-not-allowed" : ""
                            }`}
                            onClick={() => {
                              if (!isLoading) {
                                check();
                              }
                            }}
                            disabled={isLoading}
                          >
                            {isLoading ? t("Loading") + "..." : t("SaveNights")}
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </Tab>
                {/* <Tab eventKey="days" title={t("EachDaySeparately")} disabled>
                  <div className="maindashboard-table-container">
                    <div className="maindashboard-table-header">
                      <TableHeader
                        first={true}
                        icon={dateIcon}
                        title={t("Date")}
                      />
                      <TableHeader icon={hotelsIcon} title={t("Hotels")} />
                      <TableHeader icon={flightIcon} title={t("Flights")} />
                      <TableHeader
                        icon={activitiesIcon}
                        title={t("Activities")}
                      />
                      <TableHeader icon={servicesIcon} title={t("Services")} />
                    </div>
                    <div className="maindashboard-table-body">
                      {days.map((day, index) => {
                        const dateKey = day.date.toISOString();
                        return (
                          <ComponentRowByDay
                            key={dateKey}
                            date={day.date}
                            formatDate={formatDate}
                            selectedHotels={null}
                            dayNumber={index + 1}
                            destinationsWithDates={destinationsWithDates}
                            hotel={selectedDayHotels[dateKey]}
                            onAddHotel={() => handleOpenDayHotel(day.date)}
                            // onShowHotel={(hotel) =>
                            //   handleShowHotel(hotel, day.date)
                            // }
                            onRemoveHotel={() => {
                              const newHotels = { ...selectedDayHotels };
                              delete newHotels[dateKey];
                              setSelectedDayHotels(newHotels);
                            }}
                          />
                        );
                      })}
                    </div>
                  </div>
                </Tab> */}
              </Tabs>
            </div>
          )}

          <Modal
            show={open}
            onHide={() => {
              setOpen(false);
            }}
            className={`add-hotel-modal  ${Lang === "ar" ? "rtl" : "ltr"}`}
          >
            <Modal.Body className="add-hotel-modal-body">
              <div className="add-hotel-logo">
                <img src={hotelsIcon} alt="hotel" />
              </div>
              <div className="add-hotel-title">{t("AddHotel")}</div>
              <div className="add-hotel-date">
                {modalContext === "destination"
                  ? // Format date range for destinations
                    `${dayjs(selectedDates.startDate).format(
                      "MMMM D"
                    )} - ${dayjs(selectedDates.endDate).format("MMMM D")}`
                  : // Format single date for days
                    dayjs(selectedDates.startDate).format("MMMM D")}
              </div>
              <div className="add-hotel-desc">{t("AddHotelDescription")}</div>
              <div className="add-hotel-modal-btns">
                <div
                  className={`add-hotel-modal-btn ${
                    chooseHotel ? "active" : ""
                  }`}
                  onClick={handleChooseHotel}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22Z"
                      stroke="#A09F9F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M2 12H22"
                      stroke="#A09F9F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 22C14.209 22 16 17.523 16 12C16 6.477 14.209 2 12 2C9.791 2 8 6.477 8 12C8 17.523 9.791 22 12 22Z"
                      stroke="#A09F9F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M4.9292 5.07101C5.85679 6.00093 6.95898 6.7384 8.17244 7.24106C9.38591 7.74371 10.6867 8.00163 12.0002 8.00001C13.3137 8.00163 14.6145 7.74371 15.828 7.24106C17.0414 6.7384 18.1436 6.00093 19.0712 5.07101M19.0712 18.929C18.1436 17.9991 17.0414 17.2616 15.828 16.759C14.6145 16.2563 13.3137 15.9984 12.0002 16C10.6867 15.9984 9.38591 16.2563 8.17244 16.759C6.95898 17.2616 5.85679 17.9991 4.9292 18.929"
                      stroke="#A09F9F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <div className="add-hotel-modal-btn-title">
                    {t("ChooseHotelFromAllTimes")}
                  </div>
                </div>
                <div
                  className={`add-hotel-modal-btn ${addManual ? "active" : ""}`}
                  onClick={handleAddHotel}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V12"
                      stroke="#A09F9F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.3751 2.62501C18.7729 2.22719 19.3125 2.00369 19.8751 2.00369C20.4377 2.00369 20.9773 2.22719 21.3751 2.62501C21.7729 3.02284 21.9964 3.5624 21.9964 4.12501C21.9964 4.68762 21.7729 5.22719 21.3751 5.62501L12.3621 14.639C12.1246 14.8763 11.8313 15.0499 11.5091 15.144L8.63609 15.984C8.55005 16.0091 8.45883 16.0106 8.372 15.9884C8.28517 15.9661 8.20592 15.9209 8.14254 15.8576C8.07916 15.7942 8.03398 15.7149 8.01174 15.6281C7.98949 15.5413 7.991 15.4501 8.01609 15.364L8.85609 12.491C8.95062 12.1691 9.12463 11.8761 9.36209 11.639L18.3751 2.62501Z"
                      stroke="#A09F9F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <div className="add-hotel-modal-btn-title">
                    {t("AddHotelManually")}
                  </div>
                </div>
              </div>
              <div
                className={`add-hotel-modal-submit ${
                  chooseHotel || addManual ? "active" : ""
                }`}
                onClick={handleContinue}
              >
                {t("Continue")}
              </div>
            </Modal.Body>
          </Modal>

          <Modal
            show={openFlight}
            onHide={() => {
              setOpenFlight(false);
            }}
            className={`add-hotel-modal  ${Lang === "ar" ? "rtl" : "ltr"}`}
          >
            <Modal.Body className="add-hotel-modal-body">
              <div className="add-hotel-logo">
                <img src={flightIcon} alt="flight" />
              </div>
              <div className="add-hotel-title">{t("AddFlight")}</div>
              <div className="add-hotel-date">
                {modalContext === "destination"
                  ? // Format date range for destinations
                    `${dayjs(selectedDates.startDate).format(
                      "MMMM D"
                    )} - ${dayjs(selectedDates.endDate).format("MMMM D")}`
                  : // Format single date for days
                    dayjs(selectedDates.startDate).format("MMMM D")}
              </div>
              <div className="add-hotel-desc">{t("AddFlightDescription")}</div>
              <div className="add-hotel-modal-btns">
                <div
                  className={`add-hotel-modal-btn ${
                    chooseFlight ? "active" : ""
                  }`}
                  onClick={handleChooseFlight}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22Z"
                      stroke="#A09F9F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M2 12H22"
                      stroke="#A09F9F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 22C14.209 22 16 17.523 16 12C16 6.477 14.209 2 12 2C9.791 2 8 6.477 8 12C8 17.523 9.791 22 12 22Z"
                      stroke="#A09F9F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M4.9292 5.07101C5.85679 6.00093 6.95898 6.7384 8.17244 7.24106C9.38591 7.74371 10.6867 8.00163 12.0002 8.00001C13.3137 8.00163 14.6145 7.74371 15.828 7.24106C17.0414 6.7384 18.1436 6.00093 19.0712 5.07101M19.0712 18.929C18.1436 17.9991 17.0414 17.2616 15.828 16.759C14.6145 16.2563 13.3137 15.9984 12.0002 16C10.6867 15.9984 9.38591 16.2563 8.17244 16.759C6.95898 17.2616 5.85679 17.9991 4.9292 18.929"
                      stroke="#A09F9F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <div className="add-hotel-modal-btn-title">
                    {t("ChooseFlightFromAllTimes")}
                  </div>
                </div>
                <div
                  className={`add-hotel-modal-btn ${
                    addManualFlight ? "active" : ""
                  }`}
                  onClick={handleAddFlight}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V12"
                      stroke="#A09F9F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.3751 2.62501C18.7729 2.22719 19.3125 2.00369 19.8751 2.00369C20.4377 2.00369 20.9773 2.22719 21.3751 2.62501C21.7729 3.02284 21.9964 3.5624 21.9964 4.12501C21.9964 4.68762 21.7729 5.22719 21.3751 5.62501L12.3621 14.639C12.1246 14.8763 11.8313 15.0499 11.5091 15.144L8.63609 15.984C8.55005 16.0091 8.45883 16.0106 8.372 15.9884C8.28517 15.9661 8.20592 15.9209 8.14254 15.8576C8.07916 15.7942 8.03398 15.7149 8.01174 15.6281C7.98949 15.5413 7.991 15.4501 8.01609 15.364L8.85609 12.491C8.95062 12.1691 9.12463 11.8761 9.36209 11.639L18.3751 2.62501Z"
                      stroke="#A09F9F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <div className="add-hotel-modal-btn-title">
                    {t("AddFlightManually")}
                  </div>
                </div>
              </div>
              <div
                className={`add-hotel-modal-submit ${
                  chooseFlight || addManualFlight ? "active" : ""
                }`}
                onClick={handleContinueFlight}
              >
                {t("Continue")}
              </div>
            </Modal.Body>
          </Modal>

          <AddServiceModal
            url={url}
            openService={openService}
            setOpenService={setOpenService}
            selectedDates={selectedDates}
            selectedDestination={selectedDestination}
            handleAdd={async (services) => {
              if (services) {
                const success = await addComponentToQuot(services);
                if (success) {
                  setOpenService(false);
                  setShowAll(true);
                  setShowAllType("Service");
                } else {
                  console.log("Failed to add items.");
                }
              }
            }}
            onContinue={(services) => {
              handleOpenAddService();
              setOpenService(false);
              setSelectedServiceTypes(services);
              setShowAddServiceForm(true);
            }}
          />

          <AddTransportModal
            url={url}
            openTransport={openTransportation}
            setOpenTransportation={setOpenTransportation}
            handleAdd={addComponentToQuot}
            selectedDates={selectedDates}
            selectedDestination={selectedDestination}
            setshowTransportationForm={setshowTransportationForm}
            setTransportationItems={setTransportationItems}
          ></AddTransportModal>

          {/* <GlobalModal
          title={selectedComponent.component_type}
          deleteModal={deleteModal}
          setDeleteModal={setDeleteModal}
          onDelete={deleteAlreadyReservedComponent}
          onClose={() => setDeleteModal(false)}
        ></DeleteModal> */}

          <GlobalModal
            title={t("RemoveDestination")}
            subtitle={t("ConfirmationRemoveDestination")}
            globalModal={deleteModal}
            onClick={() => {
              let new_distination = destinations;
              new_distination = destinations.filter(
                (item) => item.primary_destination_row_id !== deletedRowId
              );
              updateQuotation({ destination_list: new_distination });
            }}
            onClose={() => setDeleteModal(false)}
          ></GlobalModal>

          <WarningModal
            showWanings={showWarning}
            handleClose={() => {
              setShowWarning(false);
            }}
            handleDeleteWithSave={() => {
              // const updatedDestinations = destinations.map((dest) => {
              //   const matched = destinationsWithDates.find(
              //     (d) => d.idx === dest.idx
              //   );

              //   return {
              //     ...dest,
              //     nights: destinationNights[dest.idx] ?? dest.nights,
              //     from_date: matched?.dates?.start ?? null,
              //     to_date: matched?.dates?.end ?? null,
              //   };
              // });
              // updateQuotation({
              //   destination_list: updatedDestinations,
              //   deleted_items: bookWarnings,
              // });

              const updatedDestinations = destinations.map((dest) => {
                const matched = destinationsWithDates.find(
                  (d) => d.idx === dest.idx
                );
                return {
                  ...dest,
                  nights: destinationNights[dest.idx] ?? dest.nights,
                  from_date: matched?.dates?.start ?? null,
                  to_date: matched?.dates?.end ?? null,
                };
              });
              // const lastEndDate =
              //   destinationsWithDates.length > 0
              //     ? destinationsWithDates[destinationsWithDates.length - 1].dates
              //         ?.end
              //     : null;

              const lastEndDate = lastDate
                ? lastDate
                : quotationData?.details?.end_date;

              updateQuotation({
                destination_list: updatedDestinations,
                start_date: quotationData?.details?.start_date,
                end_date: lastEndDate,
                deleted_items: bookWarnings,
              });
            }}
            bookWarnings={bookWarnings}
          ></WarningModal>

          <GlobalModal
            title={t("Warning")}
            subtitle={t("AdditionalNewDay")}
            globalModal={dateWarningPopUp}
            onClose={() => setDateWarningPopUp(false)}
            oneBtnText={t("Ok")}
            showOneBtn={true}
            disableClose={true}
          ></GlobalModal>

          <ToastContainer
            position="bottom-right"
            hideProgressBar="true"
            type="error"
          />
        </div>
      )}
    </div>
  );
};

export default CustomPackageDetails;
